<template>
  <div class="space-y-4">
    <div class="bg-white shadow overflow-hidden rounded-md">
      <div v-if="loading" class="px-6 py-4 text-center">
        <Loader />
      </div>
      <PersonAssociate v-else :contact="contact" :people="people" @associated="$emit('changed')" />
    </div>
    <CreatePersonAction v-if="!loading" :contact="contact" @created="$emit('changed')" />
  </div>
</template>

<script>
import PersonAssociate from './PersonAssociate.vue';
import CreatePersonAction from './CreatePersonAction.vue';

export default {
  components: { PersonAssociate, CreatePersonAction },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId];
    },
    people() {
      return this.$store.getters['ui/accountPeople/itemsByParent'](this.contact.accountId);
    },
  },
  created() {
    this.findPeople();
  },
  destroyed() {
    this.$store.dispatch('ui/accountPeople/clearByParent', { parentId: this.contact.accountId });
  },
  methods: {
    async findPeople() {
      try {
        this.loading = true;
        await this.$store.dispatch('ui/accountPeople/load', {
          id: this.contact.accountId,
          query: {
            filter: {
              search: `${this.contact.email} ${this.contact.phone}`,
            },
            include: 'phoneNumbers,emailAddresses',
          },
        });
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
